const FORBIDDEN_CHARS = /[<>:"/\\|?*\u0000-\u001f]/g;
const MAX_BASE_LENGTH = 80;

const EXTENSION_ALIASES: Record<string, string> = {
  jpeg: 'jpg',
  markdown: 'md',
  yml: 'yaml',
  htm: 'html',
  gzip: 'gz',
};

export function canonicalExtension(extension: string): string {
  const normalized = extension.trim().toLowerCase().replace(/^\./, '');
  return EXTENSION_ALIASES[normalized] ?? normalized;
}

/** 去掉目录、控制字符与非法字符，保证可安全落盘。 */
export function sanitizeFileName(name: string): string {
  const base = name.split(/[\\/]/).pop() ?? name;
  const cleaned = base
    .replace(FORBIDDEN_CHARS, '_')
    .replace(/\s+/g, ' ')
    .replace(/^[.\s]+/, '')
    .replace(/[.\s]+$/, '')
    .trim();
  if (!cleaned) return 'file';
  const dot = cleaned.lastIndexOf('.');
  if (dot <= 0) return cleaned.slice(0, MAX_BASE_LENGTH);
  const stem = cleaned.slice(0, dot).slice(0, MAX_BASE_LENGTH) || 'file';
  const ext = cleaned.slice(dot + 1).toLowerCase();
  return ext ? `${stem}.${ext}` : stem;
}

export function stripExtension(name: string): string {
  const sanitized = sanitizeFileName(name);
  const dot = sanitized.lastIndexOf('.');
  return dot > 0 ? sanitized.slice(0, dot) : sanitized;
}

/**
 * 确定性输出名：`原文件名（去扩展）+ .目标扩展名`。
 * 传入已存在的文件名集合时追加 `-1`、`-2` 以避免覆盖。
 */
export function buildOutputName(
  sourceName: string,
  targetExtension: string,
  existing: Iterable<string> = [],
): string {
  const stem = stripExtension(sourceName) || 'converted';
  const ext = canonicalExtension(targetExtension);
  const taken = new Set([...existing].map((item) => item.toLowerCase()));
  const candidate = `${stem}.${ext}`;
  if (!taken.has(candidate.toLowerCase())) return candidate;
  let index = 1;
  for (;;) {
    const next = `${stem}-${index}.${ext}`;
    if (!taken.has(next.toLowerCase())) return next;
    index += 1;
  }
}
